import RegisterMember from './RegisterMember'
import MemberShop from './MemberShop'
import bankPage from './bankPage'
import PrivacyNotice from './PrivacyNotice'

export default {
  RegisterMember,
  MemberShop,
  bankPage,
  PrivacyNotice
}



// WEBPACK FOOTER //
// ./src/components/Register/index.js